<template>
  <div>
    <v-flex>
      <v-data-iterator
        hide-default-footer
        :disable-pagination="true"
        :items="userClients">
        <template v-slot:default="props">
          <v-layout
            v-for="(item, index) in props.items"
            :key="index"
            wrap
            row>
            <v-flex xs4 pr-2>
              <v-select
                :items="clientList"
                :value="item.clientId"
                label="Client"
                @change="updateClient(index, $event)">
              </v-select>
            </v-flex>

            <v-flex xs2 pr-2>
              <v-text-field
                type="number"
                v-model="item.databaseId"
                label="Database">
              </v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                v-model="item.clientUriOverride"
                label="Client URI Override">
              </v-text-field>
            </v-flex>
          </v-layout>
        </template>
      </v-data-iterator>
    </v-flex>
    <v-flex>
      <v-spacer></v-spacer>
      <v-btn text @click="newClient">Add Client</v-btn>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: ['clients', 'userClients'],
  data () {
    return {}
  },
  methods: {
    updateClient (i, e) {
      this.$emit('updateClient', { index: i, value: e })
    },
    newClient () {
      this.$emit('newClient', true)
    }
  },
  computed: {
    clientList () {
      return this.clients.map(c => {
        return {
          text: c.clientCode,
          value: c.clientId
        }
      })
    }
  }
}
</script>

<style>

</style>
